import { jsPDF } from "jspdf";

export function generateTaxInvoicePdf(orderId, order, hsnSummary, totals, company) {
  company = company || {};
  order = order || {};
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // 1. Header
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(16);
  pdf.text(company.name || "TAX INVOICE", pageWidth / 2, 15, { align: "center" });

  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.text(company.address1 || "", pageWidth / 2, 21, { align: "center" });
  pdf.text(`${company.place || ""} - ${company.pincode || ""}`, pageWidth / 2, 25, { align: "center" });
  pdf.text(`GSTIN: ${company.gstin || ""}`, pageWidth / 2, 29, { align: "center" });

  pdf.setLineWidth(0.1);
  pdf.line(10, 33, pageWidth - 10, 33);

  // 2. Billing Details
  pdf.setFont("helvetica", "bold");
  pdf.text("Bill To:", 12, 38);
  pdf.setFont("helvetica", "normal");
  pdf.text(order.partyName || "", 12, 43);
  pdf.text(order.address || "Consolidated Sales", 12, 47);
  pdf.text(`GSTIN: ${order.gstno || "URP"}`, 12, 51);

  pdf.setFont("helvetica", "bold");
  pdf.text("Invoice Details:", pageWidth - 70, 38);
  pdf.setFont("helvetica", "normal");
  pdf.text(`Invoice No: ${orderId}`, pageWidth - 70, 43);
  pdf.text(`Date: ${order.orderDateOnly || new Date().toISOString().slice(0, 10)}`, pageWidth - 70, 47);
  pdf.text(`Vehicle: ${order.vehicleNo || "-"}`, pageWidth - 70, 51);

  // 3. Table Header
  let y = 60;
  pdf.setFillColor(240, 240, 240);
  pdf.rect(10, y, pageWidth - 20, 8, "F");
  pdf.setFont("helvetica", "bold");
  pdf.text("S.No", 12, y + 5.5);
  pdf.text("Description", 25, y + 5.5);
  pdf.text("HSN", 75, y + 5.5);
  pdf.text("Qty", 95, y + 5.5, { align: "right" });
  pdf.text("Rate", 115, y + 5.5, { align: "right" });
  pdf.text("Taxable", 140, y + 5.5, { align: "right" });
  pdf.text("GST", 165, y + 5.5, { align: "right" });
  pdf.text("Total", pageWidth - 12, y + 5.5, { align: "right" });

  // 4. Table Content
  y += 8;
  pdf.setFont("helvetica", "normal");
  let index = 1;

  Object.entries(hsnSummary).forEach(([hsn, r]) => {
    pdf.text(String(index++), 12, y + 5);
    pdf.text("CIGARETTE", 25, y + 5);
    pdf.text(hsn, 75, y + 5);
    pdf.text(Number(r.qty).toFixed(0), 95, y + 5, { align: "right" });
    pdf.text(Number(r.basic / r.qty).toFixed(2), 115, y + 5, { align: "right" });
    pdf.text(Number(r.basic).toFixed(2), 140, y + 5, { align: "right" });
    pdf.text(Number(r.gstAmt).toFixed(2), 165, y + 5, { align: "right" });
    pdf.text(Number(r.total).toFixed(2), pageWidth - 12, y + 5, { align: "right" });
    y += 7;
    if (y > pageHeight - 60) { pdf.addPage(); y = 20; }
  });

  // 5. Totals
  pdf.line(10, y + 2, pageWidth - 10, y + 2);
  y += 8;
  pdf.setFont("helvetica", "bold");
  pdf.text("TOTALS", 25, y);
  pdf.text(Number(totals.totalQty).toFixed(0), 95, y, { align: "right" });
  pdf.text(Number(totals.totalBasic).toFixed(2), 140, y, { align: "right" });
  pdf.text(Number(totals.totalGST).toFixed(2), 165, y, { align: "right" });
  pdf.text(Number(totals.grandTotal).toFixed(2), pageWidth - 12, y, { align: "right" });

  // 6. GST Summary Breakup
  y += 15;
  pdf.setFontSize(8);
  pdf.text("GST BREAKUP SUMMARY", 12, y);
  y += 5;
  pdf.rect(10, y, pageWidth - 20, 6, "F");
  pdf.text("HSN", 12, y + 4.5);
  pdf.text("Taxable", 40, y + 4.5, { align: "right" });
  pdf.text("CGST Amt", 70, y + 4.5, { align: "right" });
  pdf.text("SGST Amt", 100, y + 4.5, { align: "right" });
  pdf.text("Cess", 130, y + 4.5, { align: "right" });
  pdf.text("Addl Cess", 160, y + 4.5, { align: "right" });
  pdf.text("Total Tax", pageWidth - 12, y + 4.5, { align: "right" });

  y += 6;
  pdf.setFont("helvetica", "normal");
  Object.entries(hsnSummary).forEach(([hsn, r]) => {
    pdf.text(hsn, 12, y + 4);
    pdf.text(Number(r.basic).toFixed(2), 40, y + 4, { align: "right" });
    pdf.text(Number(r.gstAmt / 2).toFixed(2), 70, y + 4, { align: "right" });
    pdf.text(Number(r.gstAmt / 2).toFixed(2), 100, y + 4, { align: "right" });
    pdf.text(Number(r.cessAmt).toFixed(2), 130, y + 4, { align: "right" });
    pdf.text(Number(r.addlAmt).toFixed(2), 160, y + 4, { align: "right" });
    pdf.text(Number(r.gstAmt + r.cessAmt + r.addlAmt).toFixed(2), pageWidth - 12, y + 4, { align: "right" });
    y += 5;
  });

  // 7. Footer
  const footerY = pageHeight - 30;
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text("For " + (company.name || "QUICKBILL").toUpperCase(), pageWidth - 60, footerY, { align: "center" });
  pdf.setFont("helvetica", "normal");
  pdf.text("Authorized Signatory", pageWidth - 60, footerY + 15, { align: "center" });

  pdf.setFontSize(7);
  pdf.text("Terms: Goods once sold will not be taken back. This is a computer generated invoice.", 12, pageHeight - 10);

  return pdf;
}
